import { AiFillCloseCircle } from "react-icons/ai";
import format from "date-fns/format";
import styles from "../../pages/BulkSchema/styles.module.sass";

const DATE_FORMAT = "dd MMM yyyy, HH:mm:ss";

const SchemaImage = ({ scheme, date, isAgent, onDelete }) => {
  if (!scheme) return null;

  const displayDate = scheme.date || date;

  return (
    <div className={styles.customClass}>
      <div className={styles.absoluteTitle}>
        {displayDate && format(new Date(displayDate), DATE_FORMAT)}
      </div>
      <img src={scheme} style={{ width: 400, height: 400 }} alt="Schema" />
      {!isAgent && (
        <div className={styles.absoluteClose} onClick={onDelete}>
          <AiFillCloseCircle />
        </div>
      )}
    </div>
  );
};

export default SchemaImage;
